import { cx } from "cva";
import React from "react";

import { Badge } from "../Badge";
import { IconButtonProps, variants } from "./";
import * as styles from "./IconButton.module.css";

export const IconButton = ({
  className,
  children,
  type = "button",
  variant = "solid",
  size,
  color,
  number,
  text,
  shadow,
  ...props
}: IconButtonProps) => {
  const badgeVariant = variant === "solid" ? "lighted" : "solid";
  const badgeColor = variant !== "solid" && color === "key" ? "primary" : undefined;

  return (
    <button type={type} className={cx(styles.button, className)} {...props}>
      <span className={variants({ variant, color, size, shadow })}>
        {children}
        {!!number && (
          <Badge number={number} variant={badgeVariant} size="s" color={badgeColor} className={styles.badge} />
        )}
      </span>
      {!!text && (
        <p className={styles.text}>
          {text.split(/<br\s*\/?>/i).map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      )}
    </button>
  );
};
